import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DnDialogModule } from '../dn-dialog/dn-dialog.module';
import { AskAppDownloadDialogComponent } from './ask-app-download-dialog.component';
import { AskLeaveDialogComponent } from './ask-leave-dialog.component';
import { ConfirmDialogComponent } from './confirm-dialog.component';
import { CustomIframeDialogComponent } from './custom-iframe-dialog.component';
import { DailySignInDialogComponent } from './daily-sign-in-dialog.component';
import { LoginRequiredDialogComponent } from './login-required-dialog.component';
import { MessageDialogComponent } from './message-dialog.component';
import { NotAllowDailySignInDialogComponent } from './not-allow-daily-sign-in-dialog.component';
import { NotAllowVideoDownloadDialogComponent } from './not-allow-video-download-dialog.component';
import { NotForselfDialogComponent } from './not-forself-dialog.component';
import { PreventDialogComponent } from './prevent-dialog.component';
import { ReportInPlayPageDialogComponent } from './report-in-play-page-dialog.component';
import { WidthdrawDialogComponent } from './widthdraw-dialog.component';
import { TeaserDetailDialogComponent } from './teaser-detail-dialog/teaser-detail-dialog.component';
import { PipesModule } from '../../_pipes/pipes.module';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../components/shared.module';
import { AskBindTelDialogComponent } from './ask-bind-tel-dialog.component';
import { AskGiveupBargainDialogComponent } from './ask-giveup-bargain-dialog.component';



@NgModule({
  declarations: [
    LoginRequiredDialogComponent,
    MessageDialogComponent,
    ConfirmDialogComponent,
    CustomIframeDialogComponent,
    PreventDialogComponent,
    WidthdrawDialogComponent,
    DailySignInDialogComponent,
    TeaserDetailDialogComponent,
    NotForselfDialogComponent,
    AskLeaveDialogComponent,
    NotAllowVideoDownloadDialogComponent,
    NotAllowDailySignInDialogComponent,
    AskAppDownloadDialogComponent,
    ReportInPlayPageDialogComponent,
    AskBindTelDialogComponent,
    AskGiveupBargainDialogComponent,
  ],
  imports: [
    CommonModule,
    DnDialogModule,
    PipesModule,
    RouterModule,
    SharedModule
  ]
})
export class DialogModule { }
